import type { FeatureFlags } from '../utils/types/FeatureFlag';

import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import getFeatureFlags from '../utils/apiRestCalls/getFeatureFlags';

export const initialFeatureFlagValues: FeatureFlags = {
  test: false,
  enable_new_renters_insurance_dashboard: false,
  'tiger-1497_ri_enrolled': false,
  'tiger-1549_enable_properties': false,
  'tiger-1520_monitoring_type': false,
};

const featureflagStore = create(
  devtools<{
    featureFlags: FeatureFlags;
    useFetchFeatureFlags: () => void;
  }>((set) => ({
    featureFlags: initialFeatureFlagValues,
    useFetchFeatureFlags: () => {
      const { data: featureFlags } = useQuery({
        queryKey: ['featureFlag'],
        queryFn: () => getFeatureFlags(),
        staleTime: Infinity,
      });
      useEffect(() => {
        if (featureFlags) {
          set({ featureFlags });
        }
      }, [featureFlags]);
    },
  })),
);

export default featureflagStore;
